import React, { useState } from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'

import { CHAT_TYPE } from '../options'
import SimpleCheckbox from '../../../Assets/Images/icons/checkbox'

import SingleChat from '../SingleChat/container/SingleChat'
import GroupChat from '../GroupChat/container/GroupChat'
import { styles } from '../styles'

import Multiselect from '../../../Components/Multiselect'
import { ROLE_ADMIN } from '../../../shared/constants'
import ReportChat from '../SingleChat/container/ReportChat'
import GenericFlatButton from '../../../Components/GenericFlatButton'
import TabsV2 from '../../../Components/TabsV2'
import { showReduxModal } from '../../../Reducers/UI/actions'
import CreateConversationModal from '../modal/CreateConversationModal'
import ClientsChat from '../SingleChat/container/ClientsChat'

const ChatV2View = ({
  classes,
  cities,
  citiesList,
  viewType,
  setViewType,
  searchRequestHandler,
  handleCreateConversation,
  conversationId,
  user,
  isLoading,
  userRole,
  chatOptions,
  getChatOptions,
  getUnreadStatuses,
  unreadStatuses,
  setConversationId,
}) => {
  const [selectedCities, setSelectedCities] = useState(['All'])
  const [showOnlyUnread, setShowOnlyUnread] = useState(false)
  const [notificationConversation, setNotificationConversation] = useState(null)
  const dispatch = useDispatch()

  const onCreateConversation = () => {
    dispatch(
      showReduxModal({
        children: (
          <CreateConversationModal
            searchRequestHandler={searchRequestHandler}
            cities={cities}
            citiesList={citiesList}
            placeholder={'Select city...'}
            handleCreateConversation={handleCreateConversation}
            isLoading={isLoading}
          />
        ),
        hideButtons: true,
        aspect: 'chat',
      }),
    )
  }

  return (
    <div className={classes.wrap}>
      <div className={classes.controlsWrapper}>
        <div className={classes.tabsContainer}>
          {chatOptions.length > 0 && (
            <TabsV2
              selectedValue={viewType}
              onPress={setViewType}
              getChatOptions={getChatOptions}
              options={chatOptions}
              unreadStatuses={unreadStatuses}
              setNotificationConversation={setNotificationConversation}
              setConversationId={setConversationId}
            />
          )}
        </div>
        <div
          className={classes.createChatButtonContainer}
          cypress_id={'createConversationBtn'}
        >
          {viewType !== CHAT_TYPE.GROUP_CHAT &&
          viewType !== CHAT_TYPE.CLIENTS_CHAT ? (
            <GenericFlatButton
              type={'filled'}
              title={'Create conversation'}
              onClick={onCreateConversation}
              disabled={!citiesList}
            />
          ) : null}
        </div>
      </div>
      {viewType === CHAT_TYPE.SINGLE_CHAT ? (
        <div>
          {citiesList && citiesList.length && userRole === ROLE_ADMIN ? (
            <Multiselect
              selectedCities={selectedCities}
              setSelectedCities={setSelectedCities}
              citiesList={citiesList}
              title={'City'}
              placeholder={'Select city...'}
            />
          ) : null}
          {viewType !== CHAT_TYPE.GROUP_CHAT ? (
            <div
              className={classes.checkboxContainer}
              cypress_id={'showUnreadConvCheckbox'}
            >
              <div
                className={classes.checkbox}
                onClick={() => setShowOnlyUnread(!showOnlyUnread)}
              >
                <SimpleCheckbox isChecked={showOnlyUnread} />
              </div>
              <p
                className={classes.checkboxLabel}
                cypress_id={'showUnreadConvCheckboxName'}
              >
                {`Show unread conversations`}
              </p>
            </div>
          ) : null}
          <SingleChat
            userId={user.id}
            conversationId={
              notificationConversation
                ? notificationConversation
                : conversationId
            }
            selectedCities={selectedCities}
            showOnlyUnread={showOnlyUnread}
            getUnreadStatuses={getUnreadStatuses}
            setViewType={setViewType}
            setNotificationConversation={setNotificationConversation}
            notificationConversation={notificationConversation}
          />
        </div>
      ) : viewType === CHAT_TYPE.REPORT_CHAT ? (
        <div>
          {citiesList && citiesList.length && userRole === ROLE_ADMIN && (
            <Multiselect
              selectedCities={selectedCities}
              setSelectedCities={setSelectedCities}
              citiesList={citiesList}
              title={'City'}
              placeholder={'Select city...'}
            />
          )}
          {viewType !== CHAT_TYPE.GROUP_CHAT && (
            <div className={classes.checkboxContainer}>
              <div
                className={classes.checkbox}
                onClick={() => setShowOnlyUnread(!showOnlyUnread)}
              >
                <SimpleCheckbox isChecked={showOnlyUnread} />
              </div>
              <p className={classes.checkboxLabel}>
                {`Show unread conversations`}
              </p>
            </div>
          )}
          <ReportChat
            userId={user.id}
            conversationId={
              notificationConversation
                ? notificationConversation
                : conversationId
            }
            selectedCities={selectedCities}
            onlyReports={true}
            showOnlyUnread={showOnlyUnread}
            getUnreadStatuses={getUnreadStatuses}
            setViewType={setViewType}
            setNotificationConversation={setNotificationConversation}
            notificationConversation={notificationConversation}
          />
        </div>
      ) : viewType === CHAT_TYPE.GROUP_CHAT ? (
        <GroupChat
          user={user}
          showOnlyUnread={showOnlyUnread}
          setNotificationConversation={setNotificationConversation}
          setViewType={setViewType}
        />
      ) : (
        <ClientsChat
          user={user}
          showOnlyUnread={showOnlyUnread}
          setNotificationConversation={setNotificationConversation}
          setViewType={setViewType}
          conversationId={
            notificationConversation ? notificationConversation : conversationId
          }
        />
      )}
    </div>
  )
}

export default injectStyles(styles)(ChatV2View)
